import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { practiceFields } from "@/mocks/siteData";

export default function FieldSection() {
  return (
    <section id="field" className="bg-background-100/70 py-20 md:py-28">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-end gap-8 lg:grid-cols-2">
          <Reveal>
            <SectionHeading
              align="left"
              kicker="Practice Area"
              title={
                <>
                  개인회생·개인파산
                  <br />
                  집중 상담 분야
                </>
              }
            />
          </Reveal>
          <Reveal delay={100}>
            <p className="text-sm leading-relaxed text-foreground-600 md:text-base">
              어떤 제도가 맞는지부터 진단해 드립니다.
              <br />
              상황에 맞는 최적의 방향을 함께 찾습니다.
            </p>
          </Reveal>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {practiceFields.map((field, i) => (
            <Reveal key={field.no} delay={i * 100}>
              <div className="group h-full rounded-lg border border-background-200/70 bg-background-50 p-6 transition-colors duration-300 hover:border-primary-700/60 md:p-7">
                <div className="flex items-center justify-between">
                  <div className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-950/60 text-primary-400">
                    <i className={`${field.icon} text-xl`} />
                  </div>
                  <span className="font-label text-2xl text-primary-900/70">{field.no}</span>
                </div>
                <h3 className="font-subheading mt-6 text-xl font-semibold text-foreground-950 md:text-2xl">
                  {field.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  {field.desc}
                </p>
                <ul className="mt-5 space-y-2">
                  {field.points.map((point) => (
                    <li key={point} className="flex items-center gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-primary-500" />
                      {point}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}